import React, { useState } from "react";
import { Pressable } from "react-native";
import Animated, { useSharedValue, useAnimatedStyle, withTiming } from "react-native-reanimated";
import { useToken } from "@gluestack-style/react";
import { Box } from "components/ui/box";
import { Typography } from "components/ui";

const CardTag = ({ tag, variant = "secondary" }: { tag: string; variant?: "primary" | "secondary" }) => {
	const resolvedSecondary = useToken("colors", "secondary");
	const resolvedPrimary = useToken("colors", "primary");
	const colorIdle = "transparent";
	const colorHover = variant === "primary" ? resolvedPrimary : resolvedSecondary;

	const [isHovered, setIsHovered] = useState(false);
	const hoverProgress = useSharedValue(0);

	const animatedStyle = useAnimatedStyle(() => {
		const backgroundColor = withTiming(hoverProgress.value === 1 ? colorHover : colorIdle, { duration: 150 });
		return {
			backgroundColor,
			borderRadius: 6,
		};
	});

	return (
		<Pressable
			key={tag}
			onHoverIn={() => {
				hoverProgress.value = 1;
				setIsHovered(true);
			}}
			onHoverOut={() => {
				hoverProgress.value = 0;
				setIsHovered(false);
			}}
		>
			<Animated.View style={animatedStyle}>
				<Box borderWidth={2} borderColor={variant === "primary" ? resolvedPrimary : resolvedSecondary} px={8} py={2} borderRadius={6}>
					<Typography.ParagraphSmall color={isHovered ? "white" : "black"}>{tag}</Typography.ParagraphSmall>
				</Box>
			</Animated.View>
		</Pressable>
	);
};

export default CardTag;
